<template>
  <div class="w-full h-fit flex rounded overflow-hidden">
    <div class="w-4 bg-primary-100" />
    <div class="p-4 bg-neutral-50">
      <slot />
    </div>
  </div>
</template>
